import { render, staticRenderFns } from "./ProjectMaintItem.vue?vue&type=template&id=2b5e0070&scoped=true"
import script from "./ProjectMaintItem.vue?vue&type=script&lang=js"
export * from "./ProjectMaintItem.vue?vue&type=script&lang=js"
import style0 from "./ProjectMaintItem.vue?vue&type=style&index=0&id=2b5e0070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5e0070",
  null
  
)

export default component.exports